import React from "react"
import HomepageData from "./data/extendedhomepage.json"
import Styles from "./css/extendedhomepage.module.scss"

class ExtendedHomepage extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      display: 'block',
      pageData: props.data,
      data: HomepageData
    }
  }

  headline(data){
    let params = new URLSearchParams(window.location.search);
    let hc = params.get("hc");
    let kw = params.get("kw");
    let bn = params.get("bn");
    let qsData = {};
    if(hc){
      qsData.headline = hc;
    }
    if(kw){
      qsData.subhead = kw;
    }
    if(bn){
      qsData.mainCTA = bn;
    }
    if(qsData){
      const queryData = Object.assign(data, qsData);
      this.setState({data: queryData});
    }
  }

  componentDidMount() {
    this.props.data.then(data => {
      const instanceData = Object.assign(this.state.data, data);
      this.setState({ data: instanceData});

      this.headline(this.state.data);
    });
  }

  render() {
    return (
      <div className = {Styles.extendedhomepage}  style={{ display: this.state.display }} >
      <div className = {Styles.allContainer}>
        <header><img className = {Styles.toplogo} src={this.state.data.logo}/>
        <ul className={Styles.navMenu}>
  {this.state.data.navMenu != undefined ? 
    this.state.data.navMenu.map((bullet, i) => {
      return (
        <li key={i}>
          <a href={bullet.path} dangerouslySetInnerHTML={{ __html: bullet.name }}></a>
        </li>
      );
    }) 
  : null}
</ul>

      	</header>

      <div className={Styles.banner}>
      		<div className = {Styles.bannerLeft}>
          
      		<h1 className = {Styles.headline}>{this.state.data.productHeadline}</h1>
      			<h2>{this.state.data.subhead}</h2>
      			{this.props.children}
      			<button
      			  data-cy="cta"
      			  className={`${Styles.st2} ${Styles.bn_param} ${Styles.cws_dl}`}
      			  onClick={() => {
      			    window.triggerInstall();
      			  }}
      			>Download</button>
            </div>
            
            </div>     

      <div className = {Styles.middle2}>
      <img alt='Manuals by Clear' src={this.state.data.clearSS}/>
      <div>
      <h3>{this.state.data.mid2Headline}</h3>
      <h4>{this.state.data.mid2Sub1}</h4>
      <p>{this.state.data.mid2Line1}</p>
      <h4>{this.state.data.mid2Sub2}</h4>
      <p>{this.state.data.mid2Line2}</p>
      <h4>{this.state.data.mid2Sub3}</h4>
      <p>{this.state.data.mid2Line3}</p>
      </div>

      </div>

      <div className = {Styles.bottom}>
      		<h3 className = {Styles.headlineMid}> {this.state.data.freedom}</h3>
          <div>
      		<div className = {Styles.bottomTile}>
          <h4>{this.state.data.freedomHead1}</h4>
          <p>{this.state.data.freedomPara1}</p>
          </div>
          <div className = {Styles.bottomTile}>
          <h4>{this.state.data.freedomHead2}</h4>
          <p>{this.state.data.freedomPara2}</p>
          </div>
          <div className = {Styles.bottomTile}>
          <h4>{this.state.data.freedomHead3}</h4>
          <p>{this.state.data.freedomPara3}</p>
          </div>
          </div>
      </div>
    
      <div className = {Styles.chunkyFooter}>
        <div>
          <h6>{this.state.data.footerHead}</h6>
          <p>{this.state.data.footerPara}</p>
        
        {this.props.children}
        <button
          data-cy="cta"
          className={`${Styles.st2} ${Styles.bn_param} ${Styles.cws_dl}`}
          onClick={() => {
            window.triggerInstall();
          }}
        >Download</button>
        </div>
        <img alt='Manuals by Clear' src={this.state.data.clearLaptop}/>
        </div>

        <div className = {Styles.lastFooter}>
        <img alt='Manuals by Clear' src={this.state.data.clearLogoVert}/>
        <div>
          <ul className={Styles.lastFooterMenu}>
  {this.state.data.lastFooterMenu1 != undefined ? 
    this.state.data.lastFooterMenu1.map((bullet, i) => {
      return (
        <li key={i}>
          <a href={bullet.path} dangerouslySetInnerHTML={{ __html: bullet.name }}></a>
        </li>
      );
    }) 
  : null}
</ul>

<ul className={Styles.lastFooterMenu}>
  {this.state.data.lastFooterMenu2 != undefined ? 
    this.state.data.lastFooterMenu2.map((bullet, i) => {
      return (
        <li key={i}>
          <a href={bullet.path} dangerouslySetInnerHTML={{ __html: bullet.name }}></a>
        </li>
      );
    }) 
  : null}
</ul>

<ul className={Styles.lastFooterMenu}>
  {this.state.data.lastFooterMenu3 != undefined ? 
    this.state.data.lastFooterMenu3.map((bullet, i) => {
      return (
        <li key={i}>
          <a href={bullet.path} dangerouslySetInnerHTML={{ __html: bullet.name }}></a>
        </li>
      );
    }) 
  : null}
</ul>
        </div>
        </div>
      </div>
    </div>
    )
  }
}
export default ExtendedHomepage
